module.exports = __webpack_public_path__ + "static/media/Done.69352e6b.svg";